export enum DealsRoutes {
  index = 'user.deals',
  base = 'user.deals.base',
  overview = 'user.deals.overview',
  pipeline = 'user.deals.pipeline',
  pipelineBase = 'user.deals.pipeline.base',
}

export enum OldDealsSettingsRouteNames {
  settingsIndex = 'user.deals.settings.index',
  settingsOverview = 'user.deals.settings.overview',
  settingsPipelineBase = 'user.deals.settings.pipelineBase',
  settingsPipeline = 'user.deals.settings.pipeline.details',
  settingsPipelineArchived = 'user.deals.settings.pipelineArchived',
  settingsPipelineStages = 'user.deals.settings.pipeline.stages',
}
